import React from "react";
import ReactDOM from "react-dom";
import { BaseProvider, LightTheme } from "baseui";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";

import "./index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/font-awesome/css/all.css";

const engine = new Styletron();

// Add your developer tools protection code here
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

if (!isLocalhost) {
  // Disable right-click context menu
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  
  
  // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && e.key === 'I') ||
      (e.ctrlKey && e.shiftKey && e.key === 'J') ||
      (e.ctrlKey && e.key === 'U')
    ) {
      e.preventDefault();
    }
  });

 // TODO: More aggressive dev tools protection - implement in future

/*
  // More reliable dev tools detection
  let devtools = false;
  
  // Funny messages array with Lakhdeep's name
  const funnyMessages = [
    "🕵️‍♂️ Nice try! But Lakhdeep saw you coming! 👀",
    "🚫 Lakhdeep's code is on vacation! Come back never! 🏖️",
    "🔍 Looking for Lakhdeep's secrets? Try asking nicely! 😄",
    "🛡️ This portfolio is protected by Lakhdeep's invisible ninjas! 🥷",
    "🎭 Lakhdeep's code is camera shy... please close the curtains!",
    "🍪 No cookies for code peekers! - Love, Lakhdeep 💝",
    "🎪 Lakhdeep's coding circus is closed! No backstage access! 🎭",
    "🔒 Lakhdeep.exe is not responding. Try hiring him instead! 😉",
    "🧙‍♂️ Lakhdeep says: Abracadabra! *poof* No code for you! ✨",
    "🎮 Game Over! Contact Lakhdeep to unlock this level! 🔓"
  ];
  
  const getRandomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];
  
  const blockDevTools = () => {
    if (!devtools) {
      devtools = true;
      document.body.innerHTML = `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999999;
          font-family: 'Arial', sans-serif;
        ">
          <h1 style="
            text-align: center;
            color: white;
            font-size: 2.5rem;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
            animation: bounce 1s infinite;
          ">
            ${getRandomMessage()}
          </h1>
        </div>
        <style>
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
        </style>
      `;
    }
  };
  
  // Method 1: Timing-based detection
  setInterval(() => {
    const start = performance.now();
    debugger;
    const end = performance.now();
    
    if (end - start > 100) {
      blockDevTools();
    }
  }, 500);

  // Method 2: Console object detection with property getter
  const consoleDetection = () => {
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: function() {
        blockDevTools();
        return 'devtools-detector';
      }
    });
    
    setInterval(() => {
      console.log(element);
      console.clear();
    }, 1000);
  };
  
  // Method 3: DevTools detection via console formatting
  setInterval(() => {
    const devtools = /./;
    devtools.toString = function() {
      blockDevTools();
      return 'devtools';
    };
    console.log('%c', devtools);
  }, 1500);

  // Method 4: Window size change detection (DevTools docking)
  let windowHeight = window.innerHeight;
  let windowWidth = window.innerWidth;
  
  window.addEventListener('resize', () => {
    if (Math.abs(window.innerHeight - windowHeight) > 160 || 
        Math.abs(window.innerWidth - windowWidth) > 160) {
      blockDevTools();
    }
    windowHeight = window.innerHeight;
    windowWidth = window.innerWidth;
  });

  // Method 5: Console method override detection
  const originalLog = console.log;
  const originalInfo = console.info;
  const originalError = console.error;
  const originalWarn = console.warn;
  
  let consoleCount = 0;
  
  ['log', 'info', 'error', 'warn'].forEach(method => {
    const original = console[method];
    console[method] = function() {
      consoleCount++;
      if (consoleCount > 10) {
        blockDevTools();
      }
      return original.apply(console, arguments);
    };
  });

  // Method 6: DevTools specific API detection
  const checkDevtools = () => {
    if (window.devtools && window.devtools.open) {
      blockDevTools();
    }
    
    if (typeof window.console === 'object' && 
        typeof window.console.firebug === 'string') {
      blockDevTools();
    }
  };
  
  setInterval(checkDevtools, 1000);

  // Method 7: Function toString manipulation detection
  const originalToString = Function.prototype.toString;
  Function.prototype.toString = function() {
    if (this === blockDevTools || this === checkDevtools) {
      blockDevTools();
    }
    return originalToString.apply(this, arguments);
  };

  // Initialize console detection
  consoleDetection();

  // Disable text selection and drag
  document.onselectstart = () => false;
  document.ondragstart = () => false;
  
  // Disable keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    if (e.ctrlKey && (e.key === 's' || e.key === 'a' || e.key === 'c' || e.key === 'v' || e.key === 'x')) {
      e.preventDefault();
    }
  });
  */
}

ReactDOM.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={LightTheme}>
      <App />
    </BaseProvider>
  </StyletronProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
